import angular from 'angular';
import Model from './model';
import AnalyticsServ from '../services/analytics';

function AccountFactory(Model, AnalyticsServ) {
	return class AccountModel extends Model {
		constructor(data = {}) {
			super(data);
			this.setApi("/account", null, {
				'get': {
					method: 'GET',
					url: '/cases',
					success: [data => {
						this.setData(data.accounts.current)
					}]
				},
				'update': {
					method: 'PUT',
					success: [data => {
						this.setData(data);
						AnalyticsServ.updated('Account')
					}]
				},
			});
		}
	}
}
AccountFactory.$inject = ['Model', 'AnalyticsServ'];

export default angular.module('models.account', [Model, AnalyticsServ])
	.factory('Account', AccountFactory)
	.service('CurrentAccount', ['Account', Account => new Account()])
	.name;



// WEBPACK FOOTER //
// ./project/models/account.js